// extracted by mini-css-extract-plugin
module.exports =  {"field":"field--xooYo","table":"table--PRETM","value-toggle":"value-toggle--_cfj1","valueToggle":"value-toggle--_cfj1"};